export const SHOW_USER_PREFERENCES_MODAL = "SHOW_USER_PREFERENCES_MODAL";
export const HIDE_USER_PREFERENCES_MODAL = "HIDE_USER_PREFERENCES_MODAL";
